import { viewportReveal, withReducedMotion } from "@/lib/motion";
import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

export function AnimatedSection({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	const reduced = useReducedMotion();
	const variants = withReducedMotion(viewportReveal, reduced);
	return (
		<motion.div
			className={className}
			variants={variants}
			initial="hidden"
			whileInView="show"
			viewport={{ once: true, margin: "-60px" }}
		>
			{children}
		</motion.div>
	);
}
